import { ERC20_ABI } from "@/constants/onchain-swap";
import { useAuthenticatedWalletConnection } from "@/hooks/core/useAuthenticatedWalletConnection";
import { useQuery } from "@tanstack/react-query";
import { formatUnits } from "viem";
import { useAccount, usePublicClient } from "wagmi";
import { arbitrum } from "wagmi/chains";

export const ARBITRUM_USDT_ADDRESS = "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9";
export const USDT_DECIMALS = 6;

export const useArbitrumUsdtBalance = () => {
  const { address } = useAccount();
  const { authenticatedWalletAddress } = useAuthenticatedWalletConnection();
  const publicClient = usePublicClient({ chainId: arbitrum.id });
  const balanceAddress = authenticatedWalletAddress ?? address;

  return useQuery({
    queryKey: ["usdtBalance", balanceAddress],
    queryFn: async () => {
      if (!balanceAddress || !publicClient) return null;

      const balance = await publicClient.readContract({
        address: ARBITRUM_USDT_ADDRESS,
        abi: ERC20_ABI,
        functionName: "balanceOf",
        args: [balanceAddress as `0x${string}`],
      });

      return {
        raw: balance,
        formatted: formatUnits(balance, USDT_DECIMALS),
      };
    },
    enabled: !!balanceAddress && !!publicClient,
    refetchInterval: 10_000,
  });
};
